module.exports = __webpack_public_path__ + "img/van-shuttle.fa1f45b5.svg";